import React, { useState, useEffect } from 'react';
import pb from '../../../lib/pocketbase';

const Invoices = ({ user }) => {
    const [invoices, setInvoices] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        if (!user?.id) return;
        const fetchInvoices = async () => {
            try {
                const records = await pb.collection('invoices').getFullList({
                    filter: `users = "${user.id}"`,
                    sort: '-created',
                });
                setInvoices(records);
            } catch (err) {
                console.error('Erreur factures:', err);
            } finally {
                setLoading(false);
            }
        };

        fetchInvoices();
    }, [user?.id]);

    if (loading) return <div className="account-content-wrapper">Chargement de vos factures...</div>;
    if (!user) return <div className="account-content-wrapper">Veuillez vous connecter.</div>;

    return (
        <div className="account-content-wrapper">
            <h2>Mes Factures</h2>
            <div className="card full-width-card" style={{ marginTop: '2rem' }}>
                <div className="table-responsive">
                    <table className="data-table">
                        <thead>
                            <tr>
                                <th>N° Facture</th>
                                <th>Date</th>
                                <th>Montant</th>
                                <th>Statut</th>
                                <th className="text-right">Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            {invoices.length > 0 ? invoices.map((inv, idx) => (
                                <tr key={inv.id}>
                                    <td className="id-cell">{inv.invoice_number}</td>
                                    <td>{new Date(inv.created).toLocaleDateString()}</td>
                                    <td><strong>{inv.amount.toLocaleString()} €</strong></td>
                                    <td><span className={`status-badge ${inv.status.toLowerCase()}`}>{inv.status}</span></td>
                                    <td className="text-right">
                                        {inv.file ? (
                                            <a
                                                href={pb.files.getUrl(inv, inv.file)}
                                                target="_blank"
                                                rel="noreferrer"
                                                className="icon-btn"
                                                title="Télécharger"
                                            >
                                                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path><polyline points="7 10 12 15 17 10"></polyline><line x1="12" y1="15" x2="12" y2="3"></line></svg>
                                            </a>
                                        ) : (
                                            <span style={{ fontSize: '0.7rem', color: '#94a3b8' }}>Bientôt disponible</span>
                                        )}
                                    </td>
                                </tr>
                            )) : (
                                <tr>
                                    <td colSpan="5" style={{ textAlign: 'center', padding: '2rem', color: '#64748b' }}>
                                        Aucune facture disponible pour le moment.
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
};

export default Invoices;

